import proj4 from 'proj4'
import { register } from 'ol/proj/proj4'

proj4.defs('EPSG:2154', '+proj=lcc +lat_0=46.5 +lon_0=3 +lat_1=49 +lat_2=44 +x_0=700000 +y_0=6600000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs')
register(proj4)

/**
 * Normalizes a CRS identifier to the short EPSG:XXXX form.
 * Handles URN (urn:ogc:def:crs:EPSG::3857), HTTP (http://www.opengis.net/def/crs/EPSG/0/3857),
 * and plain (EPSG:3857) formats.
 */
function normalizeCrs(crs: string): string {
    const match = crs.match(/(?:EPSG[/::]+|\/EPSG\/\d+\/)(\d+)$/)
    return match ? `EPSG:${match[1]}` : crs
}

/**
 * Tile load function that injects Basic auth credentials when defined on the layer service.
 * Falls back to direct src assignment when no credentials are configured.
 */
function tileLoadAuthentification(tile: any, src: string, layer: any, label: string) {
    const login = layer.service?.auth_login
    const password = layer.service?.auth_password
    if (!login || !password) {
        tile.getImage().src = src
        return
    }
    $fetch<Blob>(src, {
        headers: { Authorization: `Basic ${btoa(`${login}:${password}`)}` },
        mode: 'cors',
        responseType: 'blob',
    })
        .then((blob: Blob) => {
            const imageUrl = URL.createObjectURL(blob)
            const image = tile.getImage()
            image.onload = () => URL.revokeObjectURL(imageUrl)
            image.src = imageUrl
        })
        .catch(error => console.error(`Erreur fetch ${label}:`, error))
}

export { normalizeCrs, tileLoadAuthentification }
